import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';

import api from '../axiosConfig'; 

function CreateBxcustomer() {
  const [form, setForm] = useState({
    bxseria: '',
    bxcodfiscal: '',
    bxdenumire: '',
    bxadresa: '',
    bxregcom: '',
    bxbanca_cont: '',
    bxbanca_nume: '',
    bxtara: '',
    bxtel: '',
    bxfax: '',
    bxemail: '',
    bxcatalog_id: '',
    bxoras: '',
    bxjudet: '',
    bxcodpostal: '',
    bxinout_bool: 'Client',  // implicit
  });

  const radioItems = ['Client', 'Furnizor'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api.post('http://localhost:8000/bxcustomer', form)
      .then(() => alert('Client salvat cu succes'))
      .catch(err => alert('Eroare la salvare: ' + err.message));
  };

  return (
    <Container className="mt-4">
      <h3>Adăugare Client</h3>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Cod fiscal *</Form.Label>
              <Form.Control name="bxcodfiscal" value={form.bxcodfiscal} onChange={handleChange} required />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group>
              <Form.Label>Denumire *</Form.Label>
              <Form.Control name="bxdenumire" value={form.bxdenumire} onChange={handleChange} required />
            </Form.Group>
          </Col>


          <Col md={12}>
            <Form.Group>
              <Form.Label>Adresa *</Form.Label>
              <Form.Control name="bxadresa" value={form.bxadresa} onChange={handleChange} required />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Regcom</Form.Label>
              <Form.Control name="bxregcom" value={form.bxregcom} onChange={handleChange} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Banca cont</Form.Label>
              <Form.Control name="bxbanca_cont" value={form.bxbanca_cont} onChange={handleChange} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Banca nume</Form.Label>
              <Form.Control name="bxbanca_nume" value={form.bxbanca_nume} onChange={handleChange} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Tara *</Form.Label>
              <Form.Control name="bxtara" value={form.bxtara} onChange={handleChange} required />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Telefon</Form.Label>
              <Form.Control name="bxtel" value={form.bxtel} onChange={handleChange} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Fax</Form.Label>
              <Form.Control name="bxfax" value={form.bxfax} onChange={handleChange} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control name="bxemail" type="email" value={form.bxemail} onChange={handleChange} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Oraș *</Form.Label>
              <Form.Control name="bxoras" value={form.bxoras} onChange={handleChange} required />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Județ *</Form.Label>
              <Form.Control name="bxjudet" value={form.bxjudet} onChange={handleChange} required />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Cod poștal</Form.Label>
              <Form.Control name="bxcodpostal" value={form.bxcodpostal} onChange={handleChange} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Label>Tip client:</Form.Label>
            {radioItems.map(opt => (
              <Form.Check
                inline
                key={opt}
                label={opt}
                name="bxinout_bool"
                type="radio"
                value={opt}
                checked={form.bxinout_bool === opt}
                onChange={handleChange}
              />
            ))}
          </Col>
        </Row>

        <div className="text-end mt-4">
          <Button type="submit" variant="success" className="me-2">Salvează</Button>
          <Button variant="secondary" onClick={() => window.history.back()}>Înapoi</Button>
        </div>
      </Form>
    </Container>
  );
}

export default CreateBxcustomer;
